export interface IdentityProvider {
  id: string;
  logo: IdentityProviderLogo | undefined;
}

export enum IdentityProviderLogoType {
  SVG = 'SVG'
}

export interface IdentityProviderLogo {
  type: IdentityProviderLogoType;
  base64Content: string;
}

export function toMimeType(logoType: IdentityProviderLogoType): string {
  switch (logoType) {
    case IdentityProviderLogoType.SVG:
      return 'image/svg+xml';
    default:
      return 'image/jpeg';
  }
}

export const PROVIDER_NAME = 'keycloak';
